import { useTranslation } from "@next-platform/client-common-core";
import { Alert, AlertVariant } from "@next-platform/client-common-spicy-ui";

import { FEATURE_FLAGS } from "@/constants";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";

interface ILorebookDetailsAlertProps {
  numRejectedEntries: number;
  numNeedsReviewEntries: number;
  "data-testid"?: string;
}

export default function LorebookEntriesAlert({ numRejectedEntries, numNeedsReviewEntries, "data-testid": testId }: ILorebookDetailsAlertProps) {
  const { t } = useTranslation();
  const { hasFeatureFlag: hasLorebookImport } = useFeatureFlag(FEATURE_FLAGS.LOREBOOK_IMPORT);
  let title = "";
  let description = "";
  let alertVariant = AlertVariant.ALERT;

  if (!hasLorebookImport) {
    return null;
  }

  if (numRejectedEntries > 0) {
    title = t("lorebook:form.entriesTabModerationAlert.title");
    description = t("lorebook:form.entriesTabModerationAlert.description");
    alertVariant = AlertVariant.ALERT;
  } else if (numNeedsReviewEntries > 0) {
    title = t("lorebook:form.entriesTabTrimmedAlert.title");
    description = t("lorebook:form.entriesTabTrimmedAlert.description");
    alertVariant = AlertVariant.DEFAULT;
  }

  if (title && description) {
    return <Alert data-testid={testId} variant={alertVariant} title={title} description={description} visible={true} isDismissable={false} />;
  }
  return null;
}
